import styles from "./widgets.module.css";
import { useGlobalStyles } from "~/styles/context/global-styles-wrapper";
import { FC } from "react";
import {
  WidgetComponentsIdEnum,
  WidgetProps,
  HomeWidget,
  widgetData,
  WidgetCaller,
  ErrorBoundary,
  themeCssVars } from
"@commons-monorepo/index";
import { Product } from "~/common/props/orchestrator";
import MainCover from "@components-monorepo/components/main-cover/main-cover-ssr";
import Categories from "@components-monorepo/components/categories/categories-ssr";
import ProductsSlider from "@components-monorepo/components/products-slider/products-slider-ssr";
import Benefits from "@components-monorepo/components/benefits/benefits-ssr";
import HighLightBanner from "@components-monorepo/components/highlight-banner/highlight-banner-ssr";
import Testimonials from "@components-monorepo/components/testimonials/testimonials-ssr";
import Instagram from "@components-monorepo/components/instagram/instagram-ssr";
import CatalogueMainProducts from "~/modules/catalogue/components/CatalogueMainProducts";
import { useCart } from "~/modules/cart/providers/cart.provider";
import { useOutletContext } from "@remix-run/react";

export const Widgets = ({
  products,
  widgets



}: {products: Product[];widgets: HomeWidget[];}) => {
  const { theme, setStoreInformationInView } = useGlobalStyles();
  const { cartProducts, removeProduct, manuallyChangeProduct, addProduct } =
  useCart();
  const { bestCategories, storeMetadata, isMobile, hasOffers, hasWholesale } =
  useOutletContext<any>();
  const cart = {
    cartProducts,
    removeProduct,
    manuallyChangeProduct,
    addProduct
  };
  const localConfig = {
    cart: cart,
    locale: storeMetadata?.locale,
    currency: storeMetadata?.currency
  };

  const coverData = {
    isMobile,
    hasOffers,
    hasWholesale,
    setStoreInformationInView
  };

  const components: Record<
    WidgetComponentsIdEnum,
    FC<WidgetProps<any, any>>> =
  {
    product_carousel: ProductsSlider,
    products_grid: CatalogueMainProducts,
    benefits: Benefits,
    banner: HighLightBanner,
    testimonials: Testimonials,
    testimonials_ally: Testimonials,
    categories: Categories,
    instagram: Instagram,
    cover: MainCover
  };

  // themeCssVars declara aqui las variables del theme una sola vez: cualquier
  // SCSS descendiente las lee sin necesidad de recibir props.
  return (
    <div className={styles.widgets} style={themeCssVars(theme)}>
      {widgets &&
      widgets.map((widget: HomeWidget, index: number) => {
        const DynamicComponent: FC<WidgetProps<any, any>> =
        components[widget.id];
        return (
          widget.enabled &&
          DynamicComponent &&
          <ErrorBoundary key={`${widget.id}-${index}`}>
                <DynamicComponent
              id={`${widget.id}-${widget.index}`}
              type={widget.type}
              data={widgetData(widget, products, coverData, bestCategories)}
              config={{
                ...widget.configuration,
                ...widget.widget_configuration
              }}
              theme={theme}
              storeMetadata={storeMetadata}
              localConfig={localConfig}
              caller={WidgetCaller.CatalogueHome} />

              </ErrorBoundary>);


      })}
    </div>);

};